"use client";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const CheckCircleIconCpt = () => {
    return <CheckCircleIcon sx={{ color: "rgb(22 163 74)", marginRight: "4px" }} />;
};

export default CheckCircleIconCpt;
